import { Spin } from 'antd';
import type { SpinProps } from 'antd';
import s from './PageSpinner.module.scss';

type Props = { size?: SpinProps['size'] };

export function PageSpinner({ size = 'large' }: Props) {
  return (
    <div className={s.root}>
      <Spin size={size} />
    </div>
  );
}
